module.exports = __webpack_public_path__ + "img/usdt.31c15692.png";